module.exports = __webpack_public_path__ + "img/mxr-raw-dawg-overdrive.1f5c2729.jpg";